import React from "react";

interface Practitioner {
  name: string;
}

interface Item {
  drugs_name: string;
}

interface Summary {
  practitioner: Practitioner;
  specialty: string;
  prescription_date: string;
  subject: string;
  object: string;
  assesment: string;
  plan: string;
  file_url: string;
  items: Item[]; 
}

const Prescription: React.FC<{ summary: Summary }> = ({ summary }) => {
  console.log("Prescription Summary:", summary);
  return (
    <div
      style={{
        padding: "10px",
        border: "1px solid #ccc",
        borderRadius: "8px",
        backgroundColor: "#eaf4ff",
        fontSize: "12px",
        // fontFamily: "Arial, sans-serif",
        // width: "100%", // Lebar penuh
        boxSizing: "border-box", // Pastikan padding tidak menambah lebar elemen
      }}
    >
      <p style={{ margin: "0 0 10px", color: "#00bfa5", textAlign:"center" }}><b>Consultation Precription</b></p>
      <hr style={{ border: "none", borderTop: "1px solid #ddd" }}  />
      <table>
        <tr>
          <td>Doctor</td>
          <td>:</td>
          <td>{summary.practitioner?.name || "N/A"}</td>
        </tr>
        <tr>
          <td>Date</td>
          <td>:</td>
          <td>{summary.prescription_date || "N/A"}</td>
        </tr>
      </table>
     
      <hr style={{ border: "none", borderTop: "1px solid #ddd" }} />
      <table>
        <tbody>
          {summary.items?.length > 0 ? (
            <>
              {summary.items.map((item, index) => (
                <tr key={index}>
                  <td colSpan={3}>{index + 1}. {item.drugs_name || "N/A"}</td>
                </tr>
              ))}
              <tr>
                <td>Download File</td>
                <td>:</td>
                <td>
                  {summary.file_url ? (
                    <a
                      style={{ textDecoration: "none", color: "blue" }}
                      href={summary.file_url}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Resep
                    </a>
                  ) : (
                    "N/A"
                  )}
                </td>
              </tr>
            </>
          ) : (
            <tr>
              <td>No items available</td>
            </tr>
          )}
        </tbody>
      </table>

    </div>
  );
};

export default Prescription;
